exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myMenu[data-v-33ec43fc] .el-tooltip{text-align:center}\n", ""]);

// exports
